
import { createDraftSafeSelector, createEntityAdapter, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AnimalInfo } from "../..";
import { isEqual } from "lodash";
import { RootState } from "../../../../Store";

// WARNING make sure we are talking about the same store there will for a be two stores

export const animalDataAdapter = createEntityAdapter({
  selectId: (animal: AnimalInfo) => animal.animal_id
});


export const animalSlice = createSlice({
  name: "animals",
  initialState: animalDataAdapter.getInitialState({loading: "idle"}),
  reducers: {
    addAnimals: (state, {payload}: PayloadAction<AnimalInfo[]>) => {
      state.loading = "false";
      animalDataAdapter.addMany(state, payload);
    },
    updateAnimal: animalDataAdapter.updateOne,
    updateManyAnimals: animalDataAdapter.updateMany,
    upsertAnimals: (state, {payload}: PayloadAction<AnimalInfo[]>) => {
      const existing = animalDataAdapter.getSelectors().selectAll(state);
      if (existing.length !== payload.length || !isEqual(existing, payload)) {
        animalDataAdapter.upsertMany(state, payload);
      }
    },
    clearAnimals: animalDataAdapter.removeAll,
  },
  selectors: {
    selectByLocations: createDraftSafeSelector(
      animalDataAdapter.getSelectors().selectAll,
      (_, locationIds: number[]) => locationIds,
      (animals: AnimalInfo[], locationIds: number[]) => 
        animals.filter(animal => animal.location_id && locationIds.includes(animal.location_id))
    )
    // selectByLocations: (state, locations: number[]) => {

    // }
  }
})


export const { addAnimals, updateAnimal, updateManyAnimals, clearAnimals, upsertAnimals } = animalSlice.actions;
export const {selectById: selectAnimalById, selectAll: selectAllAnimals} = animalDataAdapter.getSelectors((state: RootState) => state.graphQlData.animals);
export const selectByLocations = animalSlice.getSelectors().selectByLocations;